module.exports = __webpack_public_path__ + "static/img/2219_phase_function_Paper_Points.535c20a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2219_phase_function_Paper_Points.png
// module id = HCmk
// module chunks = 0